import axios from 'axios';

function sendJsonRequest(method: any, url: string, headers: any, data?: any): Promise<any> {
  headers = headers || {};
  Object.assign(headers, {
    'Content-type': 'application/json; charset=UTF-8',
  });

  return new Promise((resolve, reject) => {
    axios({
      url,
      method,
      headers,
      data,
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch(reject);
  });
}

function postJson(url: string, data: any, headers: any): Promise<void> {
  return sendJsonRequest('POST', url, headers, data);
}

function putJson(url: string, data: any, headers: any): Promise<void> {
  return sendJsonRequest('PUT', url, headers, data);
}

function getJson(url: string, headers: any): Promise<any> {
  return sendJsonRequest('GET', url, headers);
}

function deleteJson(url: string, headers: any): Promise<void> {
  return sendJsonRequest('DELETE', url, headers);
}

function makeRequest(method: any, url: string): Promise<void> {
  return new Promise((resolve, reject) => {
    makeAbortableRequest(method, url, resolve, reject);
  });
}

function makeAbortableRequest(
  method: any,
  url: string,
  callbackSuccess: (response: any) => void,
  callbackError: (error: any) => void,
) {
  const xhr = new XMLHttpRequest();
  xhr.open(method, url);

  xhr.onload = function() {
    if (this.status >= 200 && this.status < 300) {
      callbackSuccess(xhr.response);
    } else {
      callbackError({
        status: this.status,
        statusText: xhr.statusText,
      });
    }
  };
  xhr.onerror = function() {
    callbackError({
      status: this.status,
      statusText: xhr.statusText,
    });
  };

  xhr.send();
  return xhr;
}

export { makeRequest, makeAbortableRequest, postJson, getJson, deleteJson, putJson };
